import { render, staticRenderFns } from "./Office.vue?vue&type=template&id=38a492a2&scoped=true"
import script from "./Office.vue?vue&type=script&lang=ts"
export * from "./Office.vue?vue&type=script&lang=ts"
import style0 from "./Office.vue?vue&type=style&index=0&id=38a492a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a492a2",
  null
  
)

export default component.exports